<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rekam Medis" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <Alert
            v-if="syncSuccess"
            :alert="{
              title: 'Sinkronisasi berhasil',
              type: 'success',
              content: `Berhasil melakukan sinkronisasi data`,
            }"
          />
          <Alert
            v-if="syncFailed"
            :alert="{
              title: 'Sinkronisasi gagal',
              type: 'danger',
              content: `Gagal melakukan sinkronisasi data`,
            }"
          />
          <div class="card-with-tab my-3">
            <div class="card-tab">
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <router-link to="/pasien" class="nav-link active"
                    >Data Rekam Medis</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/pasien/mutasi" class="nav-link"
                    >Mutasi Berkas</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/pasien/retensi" class="nav-link"
                    >Upload Berkas Fisik</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <div>
            <div class="row mb-3">
              <div class="col-md-12">
                <!-- @include('blocks.tabs') -->
                <b-tabs pills>
                  <b-tab
                    v-for="item in tabs"
                    v-bind:key="item.title + String(Math.random(1023))"
                    :title="item.title"
                    @click="() => filterTab(item.filter)"
                    :active="id_asuransi == item.filter"
                  />
                </b-tabs>
              </div>
            </div>
          </div>

          <div class="card card-filter-sort no-print">
            <div class="row">
              <div class="col-md-10">
                <FormRow
                  :row="filters"
                  @handleChange="(e) => handleChange(e)"
                />
              </div>
              <div class="col-md-2">
                <FormRow :row="sort" @handleChange="(e) => handleChange(e)" />
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <div class="row">
              <div class="col-md-3">
                <div class="row form-group mt-3">
                  <div class="col-md-12 d-flex flex-between">
                    <label class="mb-0 mr-3">Tampilkan</label>
                    <select class="form-control" v-model="perPage">
                      <option value="10">10 data</option>
                      <option v-if="totalData > 10" value="25">25 data</option>
                      <option v-if="totalData > 25" value="50">50 data</option>
                      <option v-if="totalData > 50" value="100">
                        100 data
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 offset-md-3">
                <div class="form-group mt-3">
                  <input
                    type="text"
                    class="form-control with-icon-left without-label"
                    v-model="filter"
                    placeholder="Cari data di sini"
                    ref="focusMe"
                    @keydown="$event.stopImmediatePropagation()"
                  />
                  <i class="material-symbols-outlined">search</i>
                </div>
              </div>
            </div>
            <!-- :per-page="parseInt(perPage)"  -->
            <!-- :filter="filter" -->
            <datatable
              v-if="loaded"
              :columns="columns"
              :data="rows"
              class="table table-hover responsive"
            ></datatable>
            <Loading v-else />
            <!--             <br/>
            <p v-if="rows.length">Menampilkan {{rows.length>parseInt(perPage)?perPage:rows.length}} data dari total {{rows.length}} data</p>
<datatable-pager
              v-if="loaded && rows.length"
              v-model="page"
              class="nav nav-tabs datatable-pager"
              type="abbreviated"
            ></datatable-pager> -->
            <br />
            <p v-if="totalData">
              Menampilkan {{ rows.length }} data dari total {{ totalData }} data
            </p>
            <b-pagination
              v-model="page"
              :total-rows="totalData"
              :per-page="parseInt(perPage)"
              v-on:click.native="(e) => goToPage(e)"
              align="center"
              first-number
              last-number
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Loading from "@/components/Loading.vue";
import Alert from "@/components/Alert.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
// import { HTTP } from "@/config.js";
import { data, tabs, sort, filters } from "@/data/Pasien.js";
import {
  IDataFnParams,
  ITableContentParam,
  TColumnsDefinition,
} from "vuejs-datatable";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
let n = 0;
export default {
  name: "Pasien",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
    Alert,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      syncSuccess: false,
      syncFailed: false,
      loaded: false,
      data: data,
      filters: filters,
      sort: sort,
      tabs: tabs,
      created_at: "",
      created_from: "",
      orderBy: "desc",
      id_asuransi: "",
      pembayaran: ["Umum", "BPJS", "Asuransi Lain"],
      columns: [
        {
          label: "No",
          field: "number",
        },
        {
          label: "No. RM",
          field: "no_rm",
          headerClass: "class-in-header second-class",
        },
        { label: "Pasien", field: "nama" },
        { label: "Jenis Kelamin", field: "jen_kelamin" },
        { label: "Umur", field: "formatted_umur" },
        { label: "Pembayaran", field: "pembayaran" },
        { label: "Daftar Pada", field: "formatted_created_at" },
        {
          label: "",
          class: "dropdown",
          representedAs: (
            row
          ) => `<a class="btn btn-sm btn-success btn-icon" href="/#/pasien/detail/${row.id}?fromTab=${row.fromTab}"><i class="material-symbols-outlined">open_in_new</i></a>
                <a class="btn btn-sm btn-icon btn-basic" data-toggle="dropdown" data-target="#" id="actionDropdown" aria-expanded="true">
                    <i class="material-symbols-outlined">apps</i>
                </a>
                <div class="dropdown-menu dropdown-menu-right dropdown-account" aria-labelledby="actionDropdown">
                    <a class="dropdown-item" href="/#/pasien/detail/${row.id}?fromTab=${row.fromTab}">
                        <i class="material-symbols-outlined">open_in_new</i>
                        Detail Data Pasien
                    </a>
                    <a class="dropdown-item" href="/#/pasien/form/${row.id}?fromTab=${row.fromTab}" >
                        <i class="material-symbols-outlined">create</i>
                        Edit Data Pasien
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form/${row.no_rm}?fromTab=${row.fromTab}" >
                        <i class="material-symbols-outlined">local_hospital</i>
                        Daftarkan Rawat Jalan
                    </a>
                    <a class="dropdown-item" href="/#/pasien/cetak-kartu/${row.id}?fromTab=${row.fromTab}" target="_blank" >
                        <i class="material-symbols-outlined">credit_card</i>
                        Cetak Kartu Pasien
                    </a>
                    <a class="dropdown-item" href="/#/pasien/cetak-riwayat-kontrol/${row.id}?fromTab=${row.fromTab}" target="_blank" >
                        <i class="material-symbols-outlined">print</i>
                        Cetak Riwayat Kontrol
                    </a>
                </div><div>`,
          interpolate: true,
        },
      ],
      filter: "",
      page: 1,
      countTotalRows: 0,
      perPage: 10,
      totalData: 0,
      rows: [],
    };
  },
  methods: {
    async filterTab(filter) {
      //console.log(filter);
      this["id_asuransi"] = filter;
      await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      //console.log(`${e.target.name}:${this[e.target.name]}`);
      await this.displayList();
      // this.$nextTick(() => {
      //   if (this.$refs.focusMe) {
      //     this.$refs.focusMe.focus();
      //   }
      // });
    },
    displayList: async function() {
      this.loaded = false;
      this.errors = [];
      let self = this;
      this.data.actionBtn[1].link = `${this.plainUrl}?fromTab=${this.id_asuransi}`;
      let params = `?per_page=${this.perPage}&orderColumn=created_at&orderBy=${this.orderBy}&page=${this.page}`;
      // &page=${this.page}
      // let params = `?per_page=999999999999&orderBy=${this.orderBy}`;
      if (this["filter"]) {
        params += `&cari_pasien=${this.filter}`;
      }
      // created from and created to filter
      if (this.created_from) {
        params += `&created_from=${this.created_from}`;
      } else {
        params += `&created_from=null`;
      }
      if (this.created_to) {
        params += `&created_to=${this.created_to}`;
      } else {
        params += `&created_to=null`;
      }
      // created from and created to filter
      if (this["id_asuransi"]) {
        params += `&id_asuransi=${this.id_asuransi}`;
      }
      try {
        let result = await this.$store.state.HTTP.get("pasien" + params);
        //console.log(result);
        if (result.status == "200") {
          //console.log("berhasil");
          let self = this;
          this.rows = result.data.data.map((item, index) => {
            item.pembayaran = self.pembayaran[parseInt(item.id_asuransi) - 1];
            item.number =
              ((self.page || 1) - 1) * (self.perPage || 10) + index + 1;
            item.fromTab = self.id_asuransi;
            return item;
          });
          this.totalData = result.data.total;
          //console.log(this.totalData);
          this.loaded = true;
          //console.log(this.rows);
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
    sync: async function() {
      let success = true;
      let toSend = this.rows.map((item) => {
        return {
          nama: item.nama,
          nomorTelepon: item.no_telp,
          email: item.email,
          kodeKontak: item.no_rm,
          isPelanggan: "1",
          isPemasok: "0",
          isKaryawan: "0",
        };
      });
      //console.log(JSON.stringify(toSend));
      let result = await this.$store.state.HTTP_SIAKUN.post(
        "kontak/tambah-semua-data-simrs",
        [
          ...toSend,
          {
            nama: "Pembelian Bebas",
            nomorTelepon: "",
            email: "",
            kodeKontak: "000000000",
            isPelanggan: "1",
            isPemasok: "0",
            isKaryawan: "0",
          },
        ]
      );
      //console.log(result);
      if (result.status == "200") {
        //console.log('berhasil menyimpan pasien/pelanggan ke siakun');
      } else {
        success = false;
        //console.log('Error. Gagal menyimpan pasien/pelanggan ke siakun');
      }
      // for(const item of this.rows){
      //   let result = await this.$store.state.HTTP_SIAKUN.post('kontak/tambah-simrs',{
      //       "nama": item.nama,
      //       "nomorTelepon" : item.no_telp,
      //       "kodeKontak" : item.no_rm,
      //       "isPelanggan" : "1",
      //       "isPemasok" : "0",
      //       "isKaryawan" : "0"
      //   });
      //   //console.log(result);
      //   if(result.status=='200'){
      //     //console.log('berhasil menyimpan pasien/pelanggan ke siakun');
      //   }
      //   else{
      //     success=false;
      //     //console.log('Error. Gagal menyimpan pasien/pelanggan ke siakun');
      //   }
      // }
      if (success) {
        this.syncSuccess = true;
        await this.displayList();
        this.$nextTick(() => {
          if (this.$refs.focusMe) {
            this.$refs.focusMe.focus();
          }
        });
      } else {
        this.syncFailed = true;
      }
      this.resetAlert();
    },
    resetAlert() {
      let self = this;
      setTimeout(function() {
        self.syncSuccess = false;
        self.syncFailed = false;
      }, 5000);
    },
    async goToPage(e) {
      //console.log(e.target.innerHTML);
      let trg = e.target;
      //console.log(trg);
      let char = trg.innerHTML;
      let disabled = trg.classList.contains("disabled");
      if (!disabled) {
        if (["‹", "›"].indexOf(char) < 0) {
          this.page = parseInt(char);
        }
      }
      await this.displayList();
    },
  },
  watch: {
    async perPage(newData, oldData) {
      if (newData != oldData) {
        this.page = 1;
        await this.displayList();
      }
    },
    async filter(newData, oldData) {
      if (newData != oldData) {
        this.page = 1;
        await this.displayList();
      }
    },
    // page(newData,oldData){
    //   // if(newData!=oldData){
    //   await this.displayList();
    //   // }
    // }
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    if (this.$route.query.tab) {
      this["id_asuransi"] = this.$route.query.tab;
    }
    this.data.actionBtn = [
      {
        class: "btn-outline-secondary  btn-with-icon-left",
        label: "Sync",
        type: "function",
        function: this.sync,
        iconLeft: "sync",
      },
      this.data.actionBtn[this.data.actionBtn.length - 1],
    ];
    this.plainUrl = this.data.actionBtn[1].link.split("?")[0];
    await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    //let $=jQuery;
    //bootstrap.load_file($);
  },
};
</script>
